module.exports = __webpack_public_path__ + "static/assemble-trailer-7b7c0518951f4069f6d0193a9992ab33.mp4";